<template>
    <div class="center_box">
        <n-card>
            <div class="logo_container">
                <img width="30" height="30" src="/logo.svg" alt="Винкод" />
                <span class="logo_text">Винкод</span>
            </div>
            <n-tabs
                class="card-tabs"
                default-value="signin"
                size="large"
                type="segment"
                style="margin: 0 -4px"
                pane-style="">
                <n-tab-pane name="signin" tab="Вход">
                    <Login />
                </n-tab-pane>
                <n-tab-pane name="signup" tab="Регистрация">
                    <Register />
                </n-tab-pane>
            </n-tabs>
        </n-card>
    </div>
</template>
<script lang="ts" setup>
import { NTabPane, NTabs, NCard } from "naive-ui";
import Login from "@/pages/public/Login.vue";
import Register from "@/pages/public/Register.vue";
</script>
<style scoped>
.logo_container {
    display: flex;
    align-items: flex-end;
    margin-bottom: 15px;
    justify-content: center;
}
.logo_text {
    margin-left: 5px;
    font-size: 24px;
    font-weight: 500;
}
.center_box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    padding: 0px;
    max-width: 500px;
    margin: auto;
}

.pane_style {
    padding-left: 4px;
    padding-right: 4px;
    box-sizing: border-box;
}
</style>
